<template>
    <!-- <div>
        {{all_questions.questions_clean.questions}}
    </div> -->
    <div class="temp-wrap">
        <div class="slider-wrap">
            <div class="slider sub-qa-slide">
                <div v-for="(data, id) in all_questions.questions_clean.questions">
                    <router-link :to="`/qna/clean/${id}`" :class="`clean${id}`">
                        <div class="text-wrap" v-html="data.pd_name">
                        </div>
                    </router-link>
                    
                </div>
            </div>
        </div>
        <div class="bottom-list-wrap" >
            <ul class="custom-scroller">
                <!-- <li class="ways-li">
                <div class="ways-title">{{all_questions.questions_pot.use_ways.title}}</div>
                <div class="all-ways">
                    <div class="way" v-for="(way, id) in all_questions.questions_pot.use_ways.ways">
                    <div class="num">{{id+1}}.&nbsp</div>
                    <div class="text">{{way}}</div>
                    </div>
                </div>
                </li>

                <li class="ways-li">
                <div class="ways-title">{{all_questions.questions_pot.keep_ways.title}}</div>
                <div class="all-ways">
                    <div class="way" v-for="(way, id) in all_questions.questions_pot.keep_ways.ways">
                    <div class="num">{{id+1}}.&nbsp</div>
                    <div class="text">{{way}}</div>
                    </div>
                </div>
                </li> -->

                <li class="qa-li" v-for="obj in all_datas">
                    <!-- {{obj}} -->
                    <div class="ways-title">{{obj.pd_name}}</div>
                    <ul>
                        <li v-for="(q, idx) in obj.qas" v-if="q.q==''">

                            <div class="qa-div">
                                <div class="char" v-if="q.isNum==1">{{idx+1}}</div>
                                <div class="text" v-html="q.a"></div>
                            </div>

                        </li>
                        <li v-for="q in obj.qas" v-if="q.q!=''" >
                            <div class="qa-div q">
                                <div class="char">Q :</div>
                                <div class="text">{{q.q}}</div>
                            </div>

                            <div class="qa-div" v-if="!Array.isArray(q.a)">
                                <div class="char">A :</div>
                                <div class="text" v-html="q.a"></div>
                            </div>

                            <div class="qa-div" v-else>
                                <div class="char">A :</div>
                                <div style="width: 100%">
                                    <div class="text" v-for="x in q.a" v-html="x"></div>
                                </div>    
                            </div>


                        </li>
                        
                    </ul>
                
                </li>
            </ul>
        </div>
    </div>
</template>
<script>


import ct_scroll from './function.js'
export default {
    data(){
        return {
            single_data: [],
            isActive: false
        }
    },
    props: ["id", "all_questions"],
    computed: {
        all_datas(){
            let all_datas = this.all_questions.questions_clean.questions;
            let id = (this.id==undefined)?0:this.id;
            return [
                all_datas[id]
            ];
        }
    },
    methods: {
        test(){
            //console.log(this.single_data);
            this.single_data = this.all_questions.questions_clean.questions[this.id];
            //console.log(this.single_data)
            console.log(this.single_data)
        },
        sub_qa_slide(){
            //alert()
            $('.sub-qa-slide').slick({
                focusOnSelect: true,
                // variableWidth: true,
                infinite: true,
                dots: false,
                slidesToShow: 4,
                swipeToSlide: true,
                prevArrow:`
                    <svg class='a-left control-c prev slick-prev' version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 42 24" style="enable-background:new 0 0 42 24;" xml:space="preserve">
                <style type="text/css">
                    .st0{fill:#6D6D6D;}
                </style>
                <path class="st0" d="M0,12l12,12h6L6,12L18,0h-6L0,12z M12,12l12,12h6L18,12L30,0h-6L12,12z M24,12l12,12h6L30,12L42,0h-6L24,12z"/>
                </svg>`,
                    nextArrow:`<svg class='a-right control-c next slick-next' version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 42 24" style="enable-background:new 0 0 42 24;" xml:space="preserve">
                <style type="text/css">
                    .st0{fill:#6D6D6D;}
                </style>
                <path class="st0" d="M30,0h-6l12,12L24,24h6l12-12L30,0z M18,0h-6l12,12L12,24h6l12-12L18,0z M6,0H0l12,12L0,24h6l12-12L6,0z"/>
                </svg>`,
                responsive: [
                    {
                    breakpoint: 1024,
                    settings: {
                        focusOnSelect: true,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        //infinite: true,
                        }
                    },
                    {
                    breakpoint: 991,
                    settings: {
                        focusOnSelect: true,
                        slidesToShow: 2,
                        slidesToScroll: 2
                        }
                    },
                    {
                    breakpoint: 480,
                    settings: {
                        focusOnSelect: true,
                        slidesToShow: 2,
                        slidesToScroll: 1
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ],

            })

        },
        cur_slick_click(){
            $('.sub-qa-slide').on('afterChange', (event, slick, cur)=>{
                $(`.sub-qa-slide .slick-slide[data-slick-index=${cur}] a`)[0].click()
            })
        },
        ga_func(class_name, name){
            $("body").on('click', class_name, function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        }
        
    },
    updated(){
        //this.single_data.push(this.all_questions.questions_clean.questions[this.id]);
    },
    mounted(){
        //this.single_data = this.all_questions[this.id];
        //console.log(this.single_data);
        //this.test()
        
        //console.log(this.id)
        let all_datas = this.all_questions.questions_clean.questions;
        (this.id==undefined)?this.single_data.push(all_datas[0]):this.single_data.push(all_datas[this.id]);

        
        
        this.all_questions.questions_clean.questions.forEach((e ,id)=>{
            //console.log(e.id)
            this.ga_func(".clean"+id, "常見問題-產品使用注意事項-"+e.pd_name);
        });
        
        
        this.sub_qa_slide();
        this.cur_slick_click();

        
        
        
        //console.log(this.single_data)
        //console.log()
        ct_scroll();
    }

}

</script>
<style lang="sass">
.sub-qa-slide
    margin-bottom: 20px
    .text-wrap
        padding: 15px 20px !important

.circle-dot
    list-style-type: disc

</style>


// WEBPACK FOOTER //
// src/Qna/clean.vue